"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var BasketIcon = function (props) {
    return (react_1.default.createElement("svg", __assign({ width: "24", height: "24", viewBox: "0 0 28 28" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", d: "M22 6H7L6 2H2v1.6h2.5L6 9.5c0 6.528 3.002 6.5 4 6.5h9.503v-1.6H10c-1.5 0-1.347-.882-1.347-1.23 0-.231.117-.484.66-.605L21 11.167 22 6zm-5 12c-1.125 0-2 .875-2 2s.875 2 2 2 2-.875 2-2-.875-2-2-2zm-7 0c-1.125 0-2 .875-2 2s.875 2 2 2 2-.875 2-2-.875-2-2-2z" })));
};
exports.default = BasketIcon;
